import { render, staticRenderFns } from "./GridReplacements.vue?vue&type=template&id=620e8018&"
import script from "./GridReplacements.vue?vue&type=script&lang=js&"
export * from "./GridReplacements.vue?vue&type=script&lang=js&"
import style0 from "./GridReplacements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports